import React from "react";
import logo_paris1 from "assets/logo_paris1.webp";
import logo_assas from "assets/logo_assas.webp";
import logo_sorbonne_nouvelle from "assets/logo_sorbonne_nouvelle.webp";
import logo_upec from "assets/logo_upec.webp";
import logo_uspn from "assets/logo_uspn.webp";
import logo_antilles from "assets/logo_antilles.webp";
import "./PresentationRP.scss";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Carousel } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { findManagementContentByLabel, sanitizeHtml } from "Services/functions";
import { HTMLParseOptions } from "Services/htmlParseOptions";
import { GrPrevious, GrNext } from "react-icons/gr";

/**
 * Permet d'afficher la présentation de Réseau Pro sur la page d'accueil hors connexion
 */
const PresentationRP = (props) => {
  // permet de récupérer un nombre aléatoire afin de ne pas afficher au chargement de la page toujours les mêmes universités
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  let i = getRandomInt(2);

  return (
    <div className="article_presentation" id="article_presentation">
      <div className="presentation_title">
        <Accordion>
          <AccordionTab
            header={
              <h1 className="h1_trait_dessus">Présentation Réseau Pro</h1>
            }
          >
            {parse(
              sanitizeHtml(
                findManagementContentByLabel(
                  "presentationRP",
                  props.admin.editManagement,
                  props.admin.editManagementNexus
                ).content || "presentationRPDefault"
              ),
              HTMLParseOptions
            )}
          </AccordionTab>
        </Accordion>
      </div>
      <div className="logo_container">
        <div className="logos_univ">
          <Carousel
            style={{ width: "100%" }}
            prevIcon={<GrPrevious></GrPrevious>}
            nextIcon={<GrNext></GrNext>}
          >
            <Carousel.Item>
              {i == 0 ? (
                <div className="item-carousel">
                  <img
                    src={logo_assas}
                    alt="logo de l'université Panthéon ASSAS"
                    title="Logo de l'université Panthéon ASSAS"
                  />
                  <img
                    src={logo_upec}
                    alt="logo de l'université UPEC"
                    title="Logo de l'université UPEC"
                  />

                  <img
                    src={logo_sorbonne_nouvelle}
                    alt="logo de l'université Sorbonne Nouvelle"
                    title="Logo de l'université Sorbonne Nouvelle"
                  />
                </div>
              ) : (
                <div className="item-carousel">
                  <img
                    src={logo_uspn}
                    alt="logo de l'université Sorbonne Paris Nord"
                    title="Logo de l'université Sorbonne Paris Nord"
                  />
                  <img
                    src={logo_paris1}
                    alt="logo de l'uinversité Paris 1"
                    title="Logo de l'université Paris 1"
                  />
                  <img
                    src={logo_antilles}
                    alt="logo de l'uinversité des Antilles"
                    title="Logo de l'université des Antilles"
                  />
                </div>
              )}
            </Carousel.Item>
            <Carousel.Item>
              {i == 1 ? (
                <div className="item-carousel">
                  <img
                    src={logo_assas}
                    alt="logo de l'université Panthéon ASSAS"
                    title="Logo de l'université Panthéon ASSAS"
                  />

                  <img
                    src={logo_upec}
                    alt="logo de l'université UPEC"
                    title="Logo de l'université UPEC"
                  />

                  <img
                    src={logo_sorbonne_nouvelle}
                    alt="logo de l'université Sorbonne Nouvelle"
                    title="Logo de l'université Sorbonne Nouvelle"
                  />
                </div>
              ) : (
                <div className="item-carousel">
                  <img
                    src={logo_uspn}
                    alt="logo de l'université Sorbonne Paris Nord"
                    title="Logo de l'université Sorbonne Paris Nord"
                  />
                  <img
                    src={logo_paris1}
                    alt="logo de l'uinversité Paris 1"
                    title="Logo de l'université Paris 1"
                  />
                  <img
                    src={logo_antilles}
                    alt="logo de l'uinversité des Antilles"
                    title="Logo de l'université des Antilles"
                  />
                </div>
              )}
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

PresentationRP.propTypes = {
  admin: PropTypes.object,
};
const mapStateToProps = (state) => ({
  admin: state.admin,
});

export default connect(mapStateToProps)(PresentationRP);
